export default __webpack_public_path__ + "static/media/saved-searches-icon.81589601.svg";